// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "SectionTitle-module--wrapper--Bt68g";
export var title = "SectionTitle-module--title--fHFtd";
export var subTitle = "SectionTitle-module--subTitle--iBX6U";